import PosModal from '@/components/auth/PosModal';
import StoreSelectorModal from '@/components/auth/StoreSelectorModal';
import { selectUser } from '@/redux/auth/authSlice';
import { useAppSelector } from '@/redux/hooks';
import { Layout } from 'antd';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import MyErrorBoundary from '../ErrorBoundray/ErrorBoundray';
import Seo from '../components/Seo';
import SuspenseLoader from '../components/SuspenseLoader';
import findItemByUrl from '../helpers/findItemByUrl';
import Header from './Header.layout';
import classes from './MainLayout.module.css';
import SidebarLayout from './Sidebar.layout';
import { generateItems } from './menuItems';

const { Content } = Layout;

const MainLayout = () => {
  const { t } = useTranslation(['common']);
  const user = useAppSelector(selectUser);

  const items = generateItems(t, user);
  const url = window.location.pathname;
  const activeMenuTab = findItemByUrl(url, items);

  return (
    <>
      <Seo title={activeMenuTab?.label ? `${activeMenuTab.label}` : 'Orino'} />
      <Layout style={{ minHeight: '100vh' }}>
        <SidebarLayout items={items} user={user} />
        <Layout>
          <Header activeMenuTab={activeMenuTab} />
          <Content
            style={{
              backgroundColor: 'var(--bg-clr)',
            }}
          >
            <div className={classes.content}>
              <Suspense fallback={<SuspenseLoader />}>
                <MyErrorBoundary>
                  <Outlet />
                </MyErrorBoundary>
              </Suspense>
            </div>

            {/* Store Selector Modal */}
            {user && !user?.activeStore ? (
              <StoreSelectorModal />
            ) : user && !user.devicePOS ? (
              <PosModal />
            ) : null}
          </Content>
        </Layout>
      </Layout>
    </>
  );
};

export default MainLayout;
